import { supabase } from "../lib/supabase";
import { Agent } from "../types/booking";

export interface AgentUserLink {
  id: number;
  user_id: string;
  agent_id: number;
  created_at: string;
  agent?: Agent;
}

export const fetchAgentUserByUserId = async (userId: string) => {
  try {
    const { data, error } = await supabase
      .from("agent_users")
      .select("*, agent:booking_agent(*)")
      .eq("user_id", userId)
      .maybeSingle();

    if (error) throw error;
    return { data: data as AgentUserLink | null, error: null };
  } catch (error) {
    console.error("Error fetching agent user:", error);
    return { data: null, error };
  }
};

export const fetchAllAgentUsers = async () => {
  try {
    const { data, error } = await supabase
      .from("agent_users")
      .select("*, agent:booking_agent(*)")
      .order("created_at", { ascending: false });

    if (error) throw error;
    return { data: (data || []) as AgentUserLink[], error: null };
  } catch (error) {
    console.error("Error fetching agent users:", error);
    return { data: [] as AgentUserLink[], error };
  }
};

export const linkUserToAgent = async (userId: string, agentId: number) => {
  try {
    const { data, error } = await supabase
      .from("agent_users")
      .upsert({ user_id: userId, agent_id: agentId }, { onConflict: "user_id" })
      .select("*, agent:booking_agent(*)")
      .single();

    if (error) throw error;
    return { data: data as AgentUserLink, error: null };
  } catch (error) {
    console.error("Error linking user to agent:", error);
    return { data: null, error };
  }
};

export const unlinkAgentUser = async (userId: string) => {
  try {
    const { error } = await supabase
      .from("agent_users")
      .delete()
      .eq("user_id", userId);

    if (error) throw error;
    return { success: true, error: null };
  } catch (error) {
    console.error("Error unlinking agent user:", error);
    return { success: false, error };
  }
};
